import { useCallback, useEffect, useState } from "react";
import { getClienteEmbarcacionesHistorial } from "../lib/api";

const useClienteEmbarcacionesHistorial = (clienteId, open) => {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistorial = useCallback(async () => {
    if (!clienteId) return;
    setLoading(true);
    setError(null);

    try {
      const response = await getClienteEmbarcacionesHistorial(clienteId);
      setHistorial(response.data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [clienteId]);

  useEffect(() => {
    if (open) {
      fetchHistorial();
    }
  }, [open, fetchHistorial]);

  return {
    historial,
    loading,
    error,
    refetch: fetchHistorial,
  };
};

export default useClienteEmbarcacionesHistorial;
